module.exports = __webpack_public_path__ + "static/media/shipping-bg.3df0850e.jpg";